<div class="upload-study-modal">
  <div class="modal-header">
    <h4 class="modal-title">Upload Study Files</h4>
    <button
      type="button"
      [disabled]="isUploading"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div [formGroup]="form">
      <div class="mb-3">
        <mat-checkbox
          class="me-1"
          *ngIf="!studyId && isShowCheckbox"
          (change)="onUploadSaleHorseStudyChange($event)"
          [checked]="isSaleFeatureEnabled"
        >
          <mat-label class="me-2"
            >Upload to Sale / Horse
            <i class="fa fa-spinner fa-spin" *ngIf="!(salesLoaded$ | async)"></i
          ></mat-label>
        </mat-checkbox>

        <select
          *ngIf="isSaleFeatureEnabled"
          formControlName="saleId"
          class="form-select"
          placeholder="Select Sale..."
          aria-label="Select Sale"
          (change)="updateHorses()"
          [hidden]="!(salesLoaded$ | async)"
          [attr.disabled]="this.saleId"
        >
          <option value="" disabled selected hidden>
            {{ !(salesLoaded$ | async) ? "Loading..." : "Select Sale..." }}
          </option>
          <option *ngFor="let sale of sales" [ngValue]="sale.saleId">
            {{ sale.saleName }}
          </option>
        </select>
      </div>

      <ng-container *ngIf="form.value.saleId">
        <label *ngIf="isSaleFeatureEnabled"> {{ lotOrHipText }}/Horse </label>
        <div
          class=""
          *ngIf="
            !isHorseSelected &&
            (saleHorsesLoaded$ | async) &&
            isSaleFeatureEnabled
          "
        >
          <input
            type="text"
            class="form-control"
            [placeholder]="autocompletePlacholder"
            formControlName="filter"
            (keyup)="filterHorses()"
            *ngIf="!this.horseId"
          />
          <!--<ng-autocomplete [data]="saleHorses"
                         [searchKeyword]="keyword"
                         [isLoading]="!(saleHorsesLoaded$ | async)"
                         [placeholder]="autocompletePlacholder"
                         [itemTemplate]="itemTemplate"
                         [customFilter]="customFilterFunction"
                         [notFoundTemplate]="notFoundTemplate"
                         (selected)="onHorseSelected($event)">
        </ng-autocomplete>-->
          <div class="table-scroll-section mt-2">
            <table class="table border table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" class="border-bottom-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let horse of saleHorses; let i = index"
                  (click)="onHorseSelected(horse)"
                >
                  <td>
                    <span
                      class="ms-2"
                      *ngIf="horse?.lot || horse?.horseName || horse?.dam"
                    >
                      {{ horse?.lot || "Unknown" }} |
                      {{ horse?.horseName || "Unknown" }} |
                      {{ horse?.dam || "Unknown" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          *ngIf="isHorseSelected || isSaleFeatureEnabled"
          class="text-primary fw-bold text-center selected-horses"
        >
          <span>{{ autocompletePlacholder }}</span> &nbsp;
          <i
            class="fas fa-times text-danger"
            (click)="unSelectHorse()"
            *ngIf="!this.horseId"
          ></i>
        </div>
        <div
          class="text-warning mt-3"
          *ngIf="showDuplicateMessage && isHorseSelected"
        >
          Please note: There are already study files assigned to this horse
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="form.value.horse || !isSaleFeatureEnabled">
      <div class="drag-and-drop-section">
        <div class="drop-zone" appDnd (fileDropped)="selectFiles($event)"></div>

        <div
          class="dropzone-container w-100 h-100"
          appDnd
          (fileDropped)="selectFiles($event)"
        >
          <input
            type="file"
            #fileDropRef
            id="fileUploader"
            multiple
            (change)="selectFiles($event)"
          />
          <h3 class="heading">Drag & drop your <span>files</span> here</h3>
          <h3 class="or">or</h3>
          <label class="browse-files" for="fileDropRef">Browse files</label>
          <h3 class="selected-files h3-below">
            {{
              this.selectedFiles && this.selectedFiles.length > 0
                ? this.selectedFiles.length + " files selected"
                : "0 files selected"
            }}
          </h3>
        </div>
      </div>
    </ng-container>

    <div class="drop-files-section">
      <span class="text text-success" *ngIf="isUploading"
        >Adding files to the queue</span
      >
      <span class="text text-danger" *ngIf="dicomFileValidator"
        >Please select only dicom files</span
      >
      <span class="text text-danger" *ngIf="scopeFileValidator"
        >Please select video files</span
      >
      <span class="text text-danger" *ngIf="xrayFileValidator"
        >Please select pdf/docx/doc files</span
      >
    </div>

    <div
      class="uploaded-count text-primary fw-bold text-center"
      *ngIf="activeUploadIndex"
    >
      Uploaded {{ activeUploadIndex }} of {{ selectedFiles.length }} Files...
    </div>
  </div>
  <div class="modal-footer">
    <div class="ms-3 me-3" *ngIf="isUploading">Uploading, please wait...</div>
    <button
      [disabled]="isUploading"
      type="button"
      *ngIf="isHorseSelected"
      class="btn btn-secondary"
      (click)="modal.dismiss('Close click')"
    >
      <i class="fa fa-times"></i> Cancel
    </button>
    <button
      type="button"
      *ngIf="isHorseSelected || !isSaleFeatureEnabled"
      class="btn btn-primary"
      (click)="uploadFiles()"
      [disabled]="!selectedFiles.length || isUploading || (dicomFileValidator || scopeFileValidator || xrayFileValidator)"
    >
      <i class="fa fa-upload"></i> Upload
    </button>
  </div>
</div>
